//
// Constant
//

export const initialName = 'Nouveau joueur';
export const initialEmoji = '💣';
